export const getRestartConfirmationPhrase = (service) => `restart ${service}`;

export const LOG_VIEWER_CLASS = 'w-full min-h-[300px] max-h-[45vh] overflow-y-auto overflow-x-hidden whitespace-pre-wrap break-all rounded-lg border border-olive-200 bg-slate-950 p-4 font-mono text-xs leading-5 text-slate-100';

export const getServiceBadgeClass = (state, health) => {
  if (state === 'running' && (!health || health === 'healthy')) {
    return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  }
  if (state === 'unknown') {
    return 'bg-slate-50 text-slate-600 border-slate-200';
  }
  return 'bg-amber-50 text-amber-700 border-amber-200';
};

export const normalizeLogTail = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 200;
  return Math.min(Math.max(Math.trunc(numeric), 1), 500);
};

export const normalizeFailureThreshold = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 3;
  return Math.min(Math.max(Math.trunc(numeric), 1), 100);
};

export const normalizeHealthcheckInterval = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 15;
  return Math.min(Math.max(Math.trunc(numeric), 5), 3600);
};

export const normalizeHealthcheckTimeout = (value, interval) => {
  const numeric = Number(value);
  const normalizedInterval = normalizeHealthcheckInterval(interval);
  const fallback = Math.min(5, normalizedInterval - 1);
  if (!Number.isFinite(numeric)) return fallback;
  const capped = Math.min(Math.max(Math.trunc(numeric), 1), 120);
  return Math.min(capped, normalizedInterval - 1);
};

export const parseServicesCsv = (value) => (
  (value || '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
);

export const ADMIN_TUNNEL_COMMAND = 'ssh -N -T -L 8765:127.0.0.1:8765 admin@mozart-trader.com';

export const getAdminTunnelInstructions = () => (
  'Click "Copy tunnel command", open your terminal, paste it, and reload this page.'
);
